export var GlassDamageModalSection;
(function (GlassDamageModalSection) {
    GlassDamageModalSection["DamageDescription"] = "DamageDescription";
    GlassDamageModalSection["GlazingType"] = "GlazingType";
    GlassDamageModalSection["GlassType"] = "GlassType";
    GlassDamageModalSection["Pictures"] = "Pictures";
})(GlassDamageModalSection || (GlassDamageModalSection = {}));
export const INSURER = process.env.INSURER;
export const INSURER_CONFIG = process.env.INSURER_CONFIG;
